var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner2'),_c('Simple'),_c('Advantages'),_c('Advantages2'),_c('Result'),_c('Gost'),_c('Completed'),_c('Qa')],1)}
var staticRenderFns = []

export { render, staticRenderFns }